import Vue from 'vue'
import VueI18n from 'vue-i18n';

import en from '@/locales/en.json';
import th from '@/locales/th.json';

import { defaultLocale, localeOptions } from '@/constants/config';

Vue.use(VueI18n);

const messages = {
  en: en,
  th: th
};

if (!localStorage.getItem('currentLanguage') && localeOptions.filter(x => x.id === localStorage.getItem('currentLanguage')).length <= 0) {
  localStorage.setItem('currentLanguage', defaultLocale);
}

const locale = (localStorage.getItem('currentLanguage') && localeOptions.filter(x => x.id === localStorage.getItem('currentLanguage')).length > 0) ? localStorage.getItem('currentLanguage') : defaultLocale;

export const i18n = new VueI18n({
  locale: locale,
  fallbackLocale: 'th',
  messages
});

export function language() {
  let local = '';

  if (i18n.locale === 'en') {
    local = 'Eng';
  } else {
    local = 'Local';
  }

  return local;
}
